import React from 'react';
import { useMediaQuery, useTheme } from '@mui/material';
import { CalendarFormat } from '@fitogram/react-calendar';

import { EventListWrapper } from '../EventList';
import { CalendarDesktopView } from '~/Screens/Calendar/CalendarView';
import { makeStyles } from '~/UIKit/Style';

export const useStyles = makeStyles(
  () => ({
    desktopAlert: {
      padding: '15px 0',
    },
  }),
  { name: 'CalendarPage' },
);

export const CalendarPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return isMobile ? (
    <EventListWrapper calendarFormat={CalendarFormat.week} />
  ) : (
    <CalendarDesktopView calendarFormat={CalendarFormat.month} />
  );
};
